import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import {
  LdapManagedUser,
  LdapGroupInfo,
  CreateLdapUserRequest,
  CreateLdapUserResponse,
  UpdateLdapUserRequest,
  CheckUidResponse,
  ResetPasswordResponse,
  UnarchiveLdapUserResponse,
} from 'shared';

const BASE = `${API_BASE_URL}/api/admin/ldap-users`;

export const ldapUsersApi = {
  async list(): Promise<LdapManagedUser[]> {
    const response = await axios.get(BASE);
    return response.data.data;
  },

  async listGroups(): Promise<LdapGroupInfo[]> {
    const response = await axios.get(`${BASE}/groups`);
    return response.data.data;
  },

  async checkUid(uid: string): Promise<CheckUidResponse> {
    const response = await axios.get(`${BASE}/check-uid`, { params: { uid } });
    return response.data.data;
  },

  async create(req: CreateLdapUserRequest): Promise<CreateLdapUserResponse> {
    const response = await axios.post(BASE, req);
    return response.data.data;
  },

  async update(uid: string, req: UpdateLdapUserRequest): Promise<LdapManagedUser> {
    const response = await axios.put(`${BASE}/${uid}`, req);
    return response.data.data;
  },

  async resetPassword(uid: string, password?: string): Promise<ResetPasswordResponse> {
    const response = await axios.post(`${BASE}/${uid}/reset-password`, password ? { password } : {});
    return response.data.data;
  },

  async archive(uid: string): Promise<LdapManagedUser> {
    const response = await axios.post(`${BASE}/${uid}/archive`);
    return response.data.data;
  },

  async unarchive(uid: string): Promise<UnarchiveLdapUserResponse> {
    const response = await axios.post(`${BASE}/${uid}/unarchive`);
    return response.data.data;
  },
};

export function ldapErrorMessage(err: any, fallback: string): string {
  return err?.response?.data?.error?.message || fallback;
}
